// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./assets/scripts/main.js")))
__webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./assets/styles/main.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors"], () => (__webpack_require__("./blocks/homepage-slider/homepage-slider.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
